import { HttpService } from 'core/modules/network-service';
import { get } from 'lodash';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getVisibleItems } from 'resolvers/getVisibleEntities';

/*************************************************************/

/**
 * @type {class}
 * @desc MemberCheckoutShippingOptions defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { MemberCheckoutShippingOptionsService } from 'services/memberCheckoutShippingOptions';
 *
 * // create service instance and send/cancel request
 * const memberCheckoutShippingOptionsService = new MemberCheckoutShippingOptionsService();
 * const result = await memberCheckoutShippingOptionsService.fetchData( '<user-id>' ); // fetch data
 * memberCheckoutShippingOptionsService.cancel(); // cancel an active request
 */
export class MemberCheckoutShippingOptionsService extends HttpService {

     // make request and fetch data
     async fetchComponentData( { url, data } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            // extract data
            const visibility = get( response, 'body.component.visibility', {} );
            const fields = get( response, 'body.component.structure.fields', {} );
            
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    shippingOptions: get( response, 'body.component.data.state.shippingOptions', {} ),
                    fields: getVisibleItems( fields, visibility ),
                    widgetConfig: get( response, 'body.component.structure.widgetConfig', {} ),
                },
            };
            
        } catch( errResponse ) {
            return this._errorFormatter( errResponse );
        }
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
